export class CombineProperties {
    comments = '';
    description = '';
    applicableOn = '';
    objective = '';
    method = '';
    parameterCode = '';
    parameterName = '';
    CASNumber = '';

    constructor() {
        this.comments = '';
        this.description = '';
        this.applicableOn = '';
        this.objective = '';
        this.method = '';
        this.parameterCode = '';
        this.parameterName = '';
        this.CASNumber = '';
    }
}
